import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BreadcrumbProvider } from '../../../breadcrumb/providers/breadcrumb-provider';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ModuleMenu } from "../../../common/models/menu";
import { SimpleDataSource } from "../../../common/providers/simple-data-source";
import { ConfigProvider } from "../../../config-provider.service";
import { CurrentUser } from "../../../common/providers/current-user";
import { PageContentComponent } from "../../../common/components/page-content/page-content";
import { ModuleContentComponent } from "../../../common/components/module-content/module-content";
import { NgIf, NgOptimizedImage } from "@angular/common";
import { MatButton, MatIconButton } from "@angular/material/button";
import {
  MatCell, MatCellDef,
  MatColumnDef,
  MatHeaderCell, MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable
} from "@angular/material/table";
import { MatIcon } from "@angular/material/icon";
import { MatMenu, MatMenuItem, MatMenuTrigger } from "@angular/material/menu";
import { Organization } from "../../../common/models/organization";
import { OrganizationsProvider } from "../../providers/organizations-provider";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { OrganizationMembership } from "../../../common/models/organization-membership";
import { HeaderComponent } from "../../../common/components/header-elitment/header-elitment";
import { FooterComponent } from "../../../common/components/footer-elitment/footer-elitment";

@Component({
  selector: 'organizations-organization-select-page',
  providers: [],
  styleUrls: ['./organization-select.scss'],
  standalone: true,
  imports: [
    PageContentComponent,
    ModuleContentComponent,
    NgIf,
    TranslateModule,
    MatButton,
    MatTable,
    MatHeaderRow,
    MatRow,
    MatRowDef,
    MatHeaderRowDef,
    MatHeaderCell,
    MatColumnDef,
    MatCell,
    MatCellDef,
    MatHeaderCellDef,
    NgOptimizedImage,
    MatIcon,
    RouterLink,
    MatMenuTrigger,
    MatIconButton,
    MatMenu,
    MatMenuItem,
    HeaderComponent,
    FooterComponent
  ],
  templateUrl: './organization-select.html'
})
export class OrganizationsOrganizationSelectPageComponent implements OnInit {
    public isLoading = true;
    public isRefreshLoading = false;

    public backUrl: string = '';
    public pageTitle: string = '';

    public columns: string[] = ['image', 'name', 'actions'];

    public mainActions: ModuleMenu[] = [];
    public dataSource: SimpleDataSource = new SimpleDataSource([]);
    constructor(
        public conf: ConfigProvider,
        public breadcrumbProvider: BreadcrumbProvider,
        public currentUser: CurrentUser,
        private _title: Title,
        private _router: Router,
        private _route: ActivatedRoute,
        private _toaster: MatSnackBar,
        private _dialoger: MatDialog,
        private _changeDetector: ChangeDetectorRef,
        private _translater: TranslateService,
        private organizationsProvider: OrganizationsProvider,
    ) {
    }

    public ngOnInit() {
        this.loadData().subscribe({
          next: () => {
            this.initNav();
            this.isLoading = false;
          },
          error: (error: any) => this.onError(error),
        });
    }

    public onAddOrganizationClicked(): void {
        alert('Not implemented');
    }

    public onEditClicked(event: Event, index: number) {
        alert('Not implemented');
    }

    public onDeleteClicked(event: Event, index: number) {
        alert('Not implemented');
    }

    public onRefreshDataClick(): void {
        this.refresh();
    }

    private refresh(): void {

        this.isRefreshLoading = true;
        this.loadData().subscribe({
          next: () => {
            this.isRefreshLoading = false;
          },
          error: (error: any) => {
            this.onError(error);
            this.isRefreshLoading = false;
          },
        })
    }

    private loadData(): Observable<void> {
      return this.currentUser.getOrganizationsMemberships().pipe(
        map((memberships: OrganizationMembership[]) => {
          const organizations = memberships.map((membership: OrganizationMembership) => membership.organization);
          this.dataSource = new SimpleDataSource(organizations);
        })
      );
    }

    private initNav(): void {
        this.mainActions = [
            { title: 'Add', icon: 'add', url: '', onClick: () => this.onAddOrganizationClicked() }
        ];
        this.createPageTitle();
        this.breadcrumbProvider.setDefaultCrumbs([]);
    }

    private createPageTitle(){
        this.pageTitle = this._translater.instant('Organizations');
        this._title.setTitle(this.pageTitle + ' | ' + this.conf.platformName);
    }

    private onError(error: any): void {
        this.isLoading = false;
        this.isRefreshLoading = false;
        this._toaster.open(this._translater.instant('Error_unknown'), '', { duration: 5000 });
    }
}
